import { createSlice } from '@reduxjs/toolkit';
// Slice dla aktywnej zakładki w użytkownikach
const usersSlice = createSlice({
  name: 'users', // Nazwa slice'a
  initialState: {
    checkedItems: [], // Lista zaznaczonych checkboxów
    activeUsersTab: 'Użytkownicy', // Domyślna aktywna zakładka
    currentPage: 1, // Domyślna strona
    maxPages: 2, // Domyślna maksymalna liczba stron
    role: "USER",
    sortBy: null,
    sortDirection: null, // Domyślny kierunek sortowania

    keyword: null, // Wyszukiwana fraza
    searchValue: '', // Wartość wyszukiwania

    addModalOpen: false, // Stan modala dodawania
    editModalOpen: false, // Stan modala edycji
    editedUser: null, // Dane edytowanego sportu
    needRefresh: 1, // Flaga do wymuszenia odświeżenia

    modalViewActualTab: "Dane podstawowe",

    viewedUser: "",
  },
  reducers: {
    setViewedUser(state, action) {
        state.viewedUser = action.payload;
    },
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload; // Ustawienie nowej listy zaznaczonych elementów
    },
    toggleCheckedItem: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        // Usuń id, jeśli już istnieje
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        // Dodaj id, jeśli nie istnieje
        state.checkedItems.push(id);
      }
    },
    setActiveUsersTab(state, action) {
      state.checkedItems = [];
      state.activeUsersTab = action.payload; // Aktualizacja aktywnej zakładki
      state.currentPage = 1;
      if (state.activeUsersTab === 'Użytkownicy') {
        state.role = "USER"; // Ustawienie roli na USER, gdy zakładka to 'Użytkownicy'
      } else if (state.activeUsersTab === 'Administratorzy') {
        state.role = "ADMIN"; // Ustawienie roli na ADMIN, gdy zakładka to 'Administratorzy'
      }
    },
    setPage(state, action) {
          state.checkedItems = [];
          state.currentPage = action.payload;
        },
    setMaxPages(state, action) {      
          state.maxPages = action.payload; // Aktualizacja maksymalnej liczby stron 
        },
    setSorting(state, action) {
          state.checkedItems = [];
          const { sortBy, sortDirection } = action.payload;
          state.sortBy = sortBy;
          state.sortDirection = sortDirection;
        },
    toggleNeedRefresh: (state) => {
          state.needRefresh = state.needRefresh === 1 ? 0 : 1; // Przełączanie flagi odświeżenia
        },
    toggleAddModal(state) {
          state.addModalOpen = !state.addModalOpen; // Przełączanie stanu modala dodawania
        },
    toggleEditModal(state) {
          state.editModalOpen = !state.editModalOpen;
          // state.editedSport = action.payload || null; // Ustaw dane edytowanego sportu lub resetuj
        },
    setEditModalOpen(state, action) {
      state.editModalOpen = action.payload;
    },
    setKeyword: (state, action) => {
          state.keyword = action.payload; // Ustawienie wyszukiwanej frazy
        },
    setSearchValue: (state, action) => {
          state.searchValue = action.payload; // Ustawienie wartości wyszukiwania
        },
    setModalViewActualTab(state, action) {
      state.modalViewActualTab = action.payload; // Zmieniona nazwa
      },
    }
});

export const {
  setViewedUser,
  setCheckedItems,
  toggleCheckedItem,
  setActiveUsersTab,
  setPage,
  setMaxPages,
  setSorting,
  toggleAddModal,
  toggleEditModal,
  setEditModalOpen,
  toggleNeedRefresh,
  setKeyword,
  setSearchValue,
  setModalViewActualTab
} = usersSlice.actions; // Eksport akcji
export default usersSlice.reducer;
